import { render, staticRenderFns } from "./DeleteCameraDialog.vue?vue&type=template&id=ebd7d87c"
import script from "./DeleteCameraDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCameraDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports